import React, { useState, useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Header from './header/Header';
import Body from './Body/Body';
import Footer from './Footer/Footer';
import { AuthProvider } from './Context/AuthContext';
import ReservationSystem from './Reservation/Reservation';
import ProtectedRoute from './Context/ProtectedRoute';
import GemioReservationsLanding from './Reservation/ReservationsLandingPage';

interface SearchHandlers {
  handleSearchQueryChange?: (query: string) => void;
  handleSearchFocus?: () => void;
  handleSearchBlur?: () => void;
}

interface HeaderSearchState {
  showSearch: boolean;
  searchQuery: string;
  isExpanded: boolean;
  searchSuggestions?: any[];
  selectedFilters?: string[];
  onFilterToggle?: (filter: string) => void;
}

declare global {
  interface Window {
    updateHeaderSearchState?: (
      state: HeaderSearchState,
      handlers: SearchHandlers
    ) => void;
  }
}

function App() {
  const [headerSearchState, setHeaderSearchState] = useState<HeaderSearchState>({
    showSearch: false,
    searchQuery: '',
    isExpanded: false,
    searchSuggestions: [],
    selectedFilters: [],
    onFilterToggle: undefined
  });

  useEffect(() => {
    window.updateHeaderSearchState = (state, handlers) => {
      setHeaderSearchState(state);
    };

    return () => {
      window.updateHeaderSearchState = undefined;
    };
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            element={
            <ProtectedRoute>
              <ReservationSystem />
            </ProtectedRoute>
          }>
            <Route path="/reservation/:restaurantId/:slug" />
            <Route path="/reservation/:restaurantId" />
          </Route>
          <Route
            path="/reservation"
            element={
              <GemioReservationsLanding />
          }
          />
          <Route path='*' element={
            <div className="App">
            <Header
              showSearch={headerSearchState.showSearch}
            />

            <div
              className={`transition-all duration-300 ${
                headerSearchState.showSearch ? 'h-20' : 'h-17'
              }`}
            ></div>
            <Body  />
            <Footer />
          </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
